import { render } from "./CampaignTrending.vue?vue&type=template&id=4efa829b&scoped=true"
import script from "./CampaignTrending.vue?vue&type=script&lang=js"
export * from "./CampaignTrending.vue?vue&type=script&lang=js"

import "./CampaignTrending.vue?vue&type=style&index=0&id=4efa829b&lang=scss&scoped=true"
import "./CampaignTrending.vue?vue&type=style&index=1&id=4efa829b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efa829b"]])

export default __exports__